import "core-js/modules/es.error.cause.js";
import { isCardNo } from '@/utils/validate';
import { getUploadDataList } from './request';
import examineModel from './examineModel.vue';
// import {blackTypeEnums, blackStatusEnums} from '../utils';
export default {
  data() {
    return {
      form: {
        status: undefined
      },
      columns: [{
        dataIndex: 'index',
        width: 80,
        slots: {
          title: '序号'
        },
        align: 'center',
        scopedSlots: {
          customRender: 'idx'
        }
      }, {
        dataIndex: 'jobTitle',
        width: 150,
        slots: {
          title: '工种'
        },
        align: 'center',
        scopedSlots: {
          customRender: 'jobTitle'
        }
      }, {
        dataIndex: 'mediaUrl',
        width: 150,
        slots: {
          title: '媒体类型'
        },
        align: 'center',
        scopedSlots: {
          customRender: 'mediaUrl'
        }
      }, {
        dataIndex: 'status',
        width: 150,
        slots: {
          title: '审核状态'
        },
        align: 'center',
        scopedSlots: {
          customRender: 'status'
        }
      }, {
        dataIndex: 'rejectReason',
        width: 200,
        slots: {
          title: '审核拒绝理由'
        },
        align: 'center',
        scopedSlots: {
          customRender: 'rejectReason'
        }
      }, {
        dataIndex: 'action',
        width: 150,
        slots: {
          title: '操作'
        },
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        }
      }],
      statusOptions: [{
        value: 'pending',
        label: '待审核'
      }, {
        value: 'approved',
        label: '已通过'
      }, {
        value: 'rejected',
        label: '已拒绝'
      }],
      statusEnums: {
        pending: '待审核',
        approved: '已通过',
        rejected: '已拒绝'
      },
      tableData: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      blackForm: {
        blacklistType: undefined,
        companyName: ''
      },
      addVisible: false,
      saveLoading: false,
      sceneId: '',
      examineVisible: false
    };
  },
  components: {
    examineModel
  },
  computed: {
    messageRules() {
      return {
        blacklistType: [{
          required: true,
          message: this.$t('请选择') + this.$t('黑名单类型'),
          trigger: 'change'
        }],
        companyName: [{
          required: true,
          message: this.$t('请输入企业名称'),
          trigger: 'blur'
        }, {
          min: 1,
          max: 20,
          message: this.$t('请输入1-20字符'),
          trigger: 'blur'
        }],
        idNo: [{
          required: true,
          message: this.$t('请输入人员证件号码'),
          trigger: 'blur'
        }, {
          validator: this.validateCard,
          trigger: 'blur'
        }]
      };
    }
  },
  mounted() {
    this.getDataList();
  },
  methods: {
    refreshList() {
      this.getDataList();
    },
    validateCard(rule, idcard, callback) {
      if (!isCardNo(idcard) || idcard == '') {
        callback(new Error(this.$t('请输入18位大陆身份证号')));
      } else {
        callback();
      }
    },
    batchImport() {
      this.importVisible = true;
    },
    onSearch() {
      this.pagination.current = 1;
      this.getDataList();
    },
    reset() {
      this.$refs.form.resetFields();
      this.pagination.current = 1;
      this.getDataList();
    },
    getDataList() {
      let params = {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        status: this.form.status
        // entityInfo: this.form.entityInfo.trim()
      };
      console.log(params, 'params');
      getUploadDataList(params).then(res => {
        if (res && res.items) {
          console.log(res, 'getDataList');
          this.tableData = res.items || [];
          this.pagination.total = Number(res.totalNum) || 0;
        }
      });
    },
    handleStandardTableChange(pagination) {
      this.pagination = pagination;
      this.getDataList();
    },
    openAddModal(record) {
      this.addVisible = true;
    },
    closeAddVisible() {
      this.$refs.addRef.resetFields();
      this.addVisible = false;
      this.blackForm = {
        blacklistType: undefined,
        entityInfo: ''
      };
    },
    handleExamine(record) {
      this.examineVisible = true;
      this.sceneId = record.id;
    }
  }
};